module.exports = __webpack_public_path__ + "img/Footer-Arrow-Open.6944a12.svg";